import { apiFetch } from "../../../context/AuthContext";

const API_URL = process.env.REACT_APP_BASE_URL;

/**
 * Upload a document for an employee
 * @param {string|number} employeeId
 * @param {File} file
 * @returns {Promise<object>} response data
 */
export const uploadEmployeeDocument = async (infinityCode, file, type) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("infinityCode", infinityCode);
  formData.append("type", type);
  formData.append("adminUpload", "true"); // bypass approval flow
  const response = await apiFetch(`${API_URL}/api/documents/upload`, {
    method: "POST",
    body: formData,
  });
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData?.error || errorData?.message || "Failed to upload document");
  }
  return await response.json();
};
